import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { default as ReactSelect } from 'react-select';
import { SelectCheckItem } from '~/components/filters/SelectCheckItem';

import { multiSelectStyles } from '~/common/selects.js';
import useApplyFilters from '~/core/filters/hooks/useApplyFilters';

export const MultiSelectFilterControl = props => {
	const { toggleFilter } = useApplyFilters();
	const filterOptions = props.filter.items;
	const [unselectedOptions, setUnselectedOptions] = useState([]);
	const [selectedOptions, setSelectedOptions] = useState();

	useEffect(() => {
		if (props.filter == null || props.filter.items.length == 0) {
			setUnselectedOptions([]);
			setSelectedOptions([]);
			return;
		}

		setUnselectedOptions(
			props.filter.items.map(filter => {
				return {
					label: filter.vl,
					value: filter.id
				};
			})
		);

		setSelectedOptions(
			props.filter.items.map(filter => {
				if (filter.sel) {
					return {
						label: filter.vl,
						value: filter.id
					};
				}
			})
		);
	}, [props.filter]);

	const handleFilterChange = (values, meta) => {
		const option = meta.action == 'remove-value' ? meta.removedValue : meta.option;

		const toggledOption = filterOptions.find(filterOption => filterOption.id == option.value);

		if (toggledOption) {
			toggleFilter(toggledOption.url);
		}
	};

	return (
		<div
			key={'dvFlt-' + props.filter.id}
			className="d-inline-block"
			data-toggle="popover"
			data-trigger="focus"
			data-content={props.placeholder}>
			<ReactSelect
				isMulti
				options={unselectedOptions}
				closeMenuOnSelect={false}
				hideSelectedOptions={false}
				components={{
					SelectCheckItem
				}}
				onChange={handleFilterChange}
				placeholder={props.placeholder}
				allowSelectAll
				value={selectedOptions}
				autosize
				styles={multiSelectStyles}
				classNamePrefix="select"
			/>
		</div>
	);
};

MultiSelectFilterControl.propTypes = {
	placeholder: PropTypes.string,
	filter: PropTypes.object
};
